import { Outlet } from "react-router-dom";

export default function Customers() {
  return (
    <Outlet />
  );
}